import * as React from 'react';
import injectSheet from 'react-jss';
import { TweenMax, Back } from 'gsap';

interface Props {
  messages: any;
  isVisible: boolean;
  completePercentage: number;
  currentStep?: number;
  classes: any;
}

const styleSheet = {
  bar: {
    width: '220px',
    height: '4px',
    position: 'relative',
    textAlign: 'center',
    margin: '0px auto',
  },
  barContainer: {
    width: '220px',
    height: '4px',
    borderRadius: '8px',
    backgroundColor: '#b7c1e1',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 2,
  },
  completionBar: {
    width: '0%',
    height: '100%',
    backgroundColor: '#3867fa',
  },
  confettiWrapper: {
    display: 'block',
    position: 'absolute',
    width: '80px',
    height: '80px',
    left: '0%',
    top: '-38px',
    marginLeft: '-20px',
    zIndex: 1,
  },
  message: {
    opacity: 0,
    fontSize: '14px',
    color: '#6373a4',
    textAlign: 'center',
    fontFamily: 'CircularStd, sans-serif',
    marginTop: '13px',
  },
  confettiImg: {
    width: '100%',
    height: 'auto',
  },
};

const progressBar: React.FC<Props> = props => {
  const imgRef: any = React.useRef();
  const messageRef: any = React.useRef();
  const completionBar: any = React.useRef();
  const confettiContainer: any = React.useRef();
  const progressBarContainer: any = React.useRef();

  React.useEffect(() => {
    if (imgRef.current) {
      imgRef.current.src = null;
      imgRef.current.src = 'images/UI/confetti.gif';
    }

    const t = (220 / 100) * props.completePercentage;

    // animate to percentage
    TweenMax.to(completionBar.current, 0.5, {
      width: t,
    });

    // move confetti to percentage position
    TweenMax.to(confettiContainer.current, 0.5, {
      x: t,
    });

    // If message exists, animate in
    if (messageRef) {
      TweenMax.set(messageRef.current, { opacity: 1 });
      TweenMax.from(messageRef.current, 0.75, {
        y: '+=20',
        opacity: 0,
        ease: Back.easeOut,
      });
    }
  }, [props.completePercentage]);

  const getMessage = () => {
    const { messages } = props;
    let message: string;

    if (messages) {
      message = messages.find(
        (item: any) => item.percentage === props.completePercentage
      )?.message;
      return (
        <div ref={messageRef} className={props.classes.message}>
          {message}
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <div
        data-step-id={props.currentStep}
        ref={progressBarContainer}
        className={props.classes.bar}
        style={{ display: props.isVisible ? 'block' : 'none' }}
      >
        <div className={props.classes.confettiWrapper} ref={confettiContainer}>
          <img
            className={props.classes.confettiImg}
            alt="confetti"
            ref={imgRef}
            src=""
          />
        </div>
        <div className={props.classes.barContainer}>
          <div ref={completionBar} className={props.classes.completionBar} />
        </div>
        {getMessage()}
      </div>
    </>
  );
};

export default injectSheet(styleSheet)(progressBar);
